import DOMPurify from "dompurify";

// Stored text-widget HTML is untrusted at render time: it is injected via
// dangerouslySetInnerHTML and is NOT re-parsed through Tiptap's schema on the
// read path, so the editor's input-time constraints don't apply here. Sanitize
// at the render sink to strip scripts, event handlers, and unsafe URLs while
// preserving the formatting the editor emits.

// Tags/attributes the editor (Tiptap StarterKit + textStyle/highlight/textAlign)
// can produce. `style` carries color / font-size / background-color / text-align.
const ALLOWED_TAGS = [
  "p", "br", "hr", "span",
  "strong", "b", "em", "i", "u", "s", "del", "strike", "mark", "code",
  "h1", "h2", "h3", "h4", "h5", "h6",
  "ul", "ol", "li", "blockquote",
  "a",
];

const ALLOWED_ATTR = ["style", "href", "target", "rel"];

export function sanitizeWidgetHtml(html: string): string {
  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
}
